import React from "react";
import { images } from "../utils/imagePaths";
import "../styles/footer.css";

const Footer = () => {
  const footerProducts = [
    "General Trading Solutions",
    "Super Market Solutions",
    "Textiles Solutions",
    "Pharmacy Solutions",
    "Labour Management Solutions",
    "Hospital Solutions",
    "Credit Risk Management Solutions",
    "Lab Solutions",
    "Bakery Solutions",
    "Optical Traders Solutions",
    "Production Management Solutions",
    "Online And Offline Softwares",
    "Mobile Apps Solutions",
    "Insurance Agent Solutions",
  ];

  return (
    <footer className="footer">
      <div className="footer-container">

        <div className="footer-wrapper">

          {/* LEFT */}
          <div className="footer-left">
            <div className="footer-logo">
              <img src={images.footerLogo} alt="XQlusive Softwares" />
            </div>

            <p className="footer-address">
              XXI/786A, Mala Road, Kalletumkara PO <br />
              Thrissur 680683
            </p>

            <p className="footer-phone">
              <a href="tel:+919539944599" className="phone-link">
                (+91) 9539944599
              </a>
              <span className="phone-separator"> | </span>
              <a href="tel:9823244213" className="phone-link">
                9823244213
              </a>
            </p>

            <div className="footer-social">
              <a href="#" className="social-icon facebook">
                <img src={images.icons.facebook} alt="Facebook" />
              </a>
              <a href="#" className="social-icon instagram">
                <img src={images.icons.instagram} alt="Instagram" />
              </a>
              <a href="#" className="social-icon linkedin">
                <img src={images.icons.linkedin} alt="LinkedIn" />
              </a>
              <a href="#" className="social-icon twitter">
                <img src={images.icons.twitter} alt="Twitter" />
              </a>
              <a href="#" className="social-icon youtube">
                <img src={images.icons.youtube} alt="YouTube" />
              </a>
            </div>
          </div>

          {/* RIGHT */}
          <div className="footer-right">
            <h3 className="products-heading">Products</h3>
            <div className="products-grid">
              {footerProducts.map((item, index) => (
                <a key={index} href="#" className="product-link">
                  {item}
                </a>
              ))}
            </div>
          </div>

        </div>

        <div className="footer-divider"></div>

        <p className="copyright-text">
          © 2022 XQlusive Softwares. All Rights Reserved.
        </p>

      </div>
    </footer>
  );
};

export default Footer;
